<template>
    <div class="mx-auto flex max-w-2xl flex-col gap-16 px-6 py-16 sm:rounded-3xl sm:p-8 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-10 xl:gap-x-10 xl:px-10 overflow-hidden my-8 rounded-lg bg-gradient-to-b from-[#59615a] to-[#9e9576]">
        <img class=" w-full flex-none rounded-2xl object-cover shadow-xl lg:aspect-auto lg:h-auto lg:max-w-sm"
             src="/images/gaming-dark2-qm.webp" alt="Standing desk voor gaming"/>
        <div class="w-full flex-auto">
            <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">{{ trans('pages.blogs.on_search') }}</h2>
            <p class="mt-6 text-lg leading-8 text-gray-300">{{ trans('pages.blogs.on_search_desc') }}</p>
            <ul role="list"
                class="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base leading-7 text-white sm:grid-cols-2">
                <li v-for="benefit in benefits" :key="benefit" class="flex gap-x-3">
                    <CheckCircleIcon class="h-7 w-5 flex-none" aria-hidden="true"/>
                    {{ benefit }}
                </li>
            </ul>
            <div class="mt-10 flex">
                <a hreflang="nl" :href="route('preconfig.all')" class="btn btn-outline border-white text-white btn-lg">{{ trans('pages.blogs.design_button') }}<span
                    aria-hidden="true">→</span></a>
            </div>
        </div>
    </div>
</template>

<script setup>
import {CheckCircleIcon} from '@heroicons/vue/20/solid'

const benefits = [
    'Belgische kwaliteit',
    'Stevige betrouwbare frames',
    'Gratis app voor IOS en Android',
    'Gratis levering',
]
</script>
